module.exports = __webpack_public_path__ + "static/media/text.ab54b218.md";